import React from "react";
import styled from "styled-components";
import Astronaut from "./Astronaut";

const Welcome = ({ user }) => {
  return (
    <>
      <Container>
        <Astronaut />
        <h1>
          Welcome, <span>{user.username}!</span>
        </h1>
        <h3>Select a chat to start messenging</h3>
      </Container>
    </>
  );
};

const Container = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  color: #c8c4c4;
  width: 100%;
  transition: all 5s ease-in-out;
  span {
    color: #535ffd;
  }
`;

export default Welcome;
